export default [
  // 會員管理
  {
    path: "/member-deposit",
    component: () =>
      import(
        /* webpackChunkName: "memberDeposit" */ "@/views/Member/MemberDeposit"
      ),
    name: "member-list",
  },
   // vip 等級設定
  {
    path: "/member/vip-level",
    component: () => import(/* webpackChunkName: "home" */ "@/views/Member/VipLevelSettings"),
    name: "member-vip-list",
    meta: { keepAlive: false },
  }
]